import { getApiClient } from './apiClient'

const baseURL = process.env.REACT_APP_USER_API_URL

const client = getApiClient(baseURL, true)

export const getMFAStatus = async () => {
  const { data } = await client.get('/mfa/status')
  return data
}

export const setupMFA = async () => {
  const { data } = await client.post('/mfa/setup')
  return data // { secretCode, qrCode }
}

export const verifyMFA = async (code) => {
  const { data } = await client.post('/mfa/verify', { code })
  return data
}

export const disableMFA = async () => {
  const { data } = await client.post('/mfa/preference', { enabled: false })
  return data
}
